// store/tracksListStore.js

import AlbumStore from "./album/AlbumStore";
import ProfilStore from "./profil/ProfilStore";
import GameStore from "./game/GameStore";
import ProfilPlayerStore from "./profilPlayer/profilPlayerStore.js";

// Initialisation uniquement des stores qui n'ont pas besoin de données externes
export const tracksListStore = {
  albumStore: new AlbumStore(),
  profilStore: new ProfilStore(),
  gameStore: new GameStore(),
  profilPlayerStore: new ProfilPlayerStore(),
};
